import { __ } from '@/hub-shared/utils/i18n';

/** Shown beside FEC / DSN file pickers — upload compliance is the depositor's duty. */
export default function FecDsnUploadResponsibilityNotice() {
  return (
    <p className="description fec-dsn-upload-responsibility-notice">
      {__('La conformité des fichiers que vous déposez est de votre responsabilité.')}
    </p>
  );
}
